/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import Typography from 'ggApp/shared/components/typography';
import DiscountIcon from 'ggApp/shared/icons/Discount';

import {
    CampaignWrapper,
    TitleWrapper,
} from './styles';

class CampaignBadge extends React.PureComponent {
    static propTypes = {
        title: PropTypes.object,
        description: PropTypes.string,
        className: PropTypes.string,
    };

    static defaultProps = {
        title: '',
        description: '',
        className: '',
    };

    render() {
        const { title, description, className } = this.props;
        return (
            <CampaignWrapper className={className}>
                <TitleWrapper>
                    <DiscountIcon />
                    <Typography tag="h2">
                        {title}
                    </Typography>
                </TitleWrapper>
                <Typography tag="p">
                    {description}
                </Typography>
            </CampaignWrapper>
        );
    }
}

export default CampaignBadge;
